var site = site || {};

site.direction = site.direction || {};

(function ($) {
  Drupal.behaviors.curtainsV1 = {
    attach: function (context) {
      var $module = $('.featured-products-carousel', context),
        $carousel = $('.featured-products-carousel__container', $module),
        $grid = $('ul.product__grid', $carousel),
        $gridItems = $grid.children('li'),
        numGridItems = $gridItems.length,
        numItemsShow = 3;

      if (numGridItems > numItemsShow) {
      // Remove the wrapper UL... we'll add it back later
        var gridClass = '';

        if ($gridItems.parent().is('ul')) {
          var $gridWrapper = $gridItems.parent();

          gridClass = $gridWrapper.attr('class');
          $gridItems.unwrap();
        }

        // Wrap every group of 3 items
        for (var i = 0; i < numGridItems; i += numItemsShow) {
          $gridItems
            .slice(i, i + numItemsShow)
            .wrapAll('<ul />')
            .parent()
            .addClass(gridClass)
            .wrapAll('<div />')
            .parent()
            .addClass('featured-products-carousel__slide');
        }

        // Initialize the slick carouseling
        $('.featured-products-carousel__slide', $carousel)
          .parent()
          .slick({
            rtl: site.direction.isRTL,
            speed: 700
          });
      }
    }
  };
})(jQuery);
